"use client";
import React, { useState } from "react";
import CommonImage from "@/components/common/image/CommonImage";
import { Link } from "lucide-react";
import { FaArrowRight } from "react-icons/fa6";
import HomePageService from "@/services/api/HomeService";
import CommonService from "@/services/api/CommonService";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import ContactForm from "./components/ContactForm";
import Image from "next/image";

export default function Contact() {
  const setting = useSelector((state) => state.setting.data);

  return (
    <>

      <section className="contact-us_section bg-animation section_padding">
        <div className="container">
          <div className="grid grid-cols-12">
            <div className="col-span-12 md:col-span-10 md:col-start-2">
              {/* title section */}
              <div className="section_title-center md:mb-8 sm:mb-6 mb-4">
                <h2 className="title flex items-center gap-2">
                  <span className="w-8 h-8">
                    <CommonImage
                      src="/images/admission-icon/contact-icon.png"
                      className="img-icon"
                      alt="Icon"
                    />
                  </span>
                  যোগাযোগ করুন
                </h2>
                <p className="short-des">
                  ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
                  গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে
                  আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
                </p>
              </div>

              {/* contact items */}
              <div className="contact-info-wrap">
                <div className="grid xl:grid-cols-4 xsm:grid-cols-2 grid-cols-1  gap-y-4">
                  <div className="contact-list-item">
                    <div className="icon-wrap">
                      <div className="icon">
                        <Image
                          src={"/images/admission-icon/email.png"}
                          className="icon-img"
                          alt="icon"
                          fill
                        />
                      </div>
                    </div>
                    <h3 className="title">ইমেইল</h3>
                    <p className="text"> 
                      <span>
                        {setting && setting.email_1
                          ? setting.email_1.length > 25
                            ? setting.email_1.slice(0, 25) + "..."
                            : setting.email_1
                          : ""}
                      </span>
                    </p>
                  </div>
                  <div className="contact-list-item">
                    <div className="icon-wrap">
                      <div className="icon">
                        <Image
                          src={"/images/admission-icon/branch-location.png"}
                          className="icon-img"
                          alt="icon"
                          fill
                        />
                      </div>
                    </div>
                    <h3 className="title"> লোকেশন</h3>
                    <p className="text"> {setting?.address}</p>
                  </div>
                  <div className="contact-list-item">
                    <div className="icon-wrap">
                      <div className="icon">
                        <Image
                          src={"/images/admission-icon/phone-call.png"}
                          className="icon-img"
                          alt="icon"
                          fill
                        />
                      </div>
                    </div>
                    <h3 className="title">ফোন নাম্বার</h3>
                    <a className="text" href={`tel:${setting?.phone_1}`}>
                      ফোকাস {setting?.phone_1}
                    </a>
                  </div>
                  <div className="contact-list-item">
                    <div className="icon-wrap">
                      <div className="icon">
                        <Image
                          src={"/images/admission-icon/watch.png"}
                          className="icon-img"
                          alt="icon"
                          fill
                        />
                      </div>
                    </div>
                    <h3 className="title">অফিস টাইম</h3>
                    <p className="text">সকাল ৯ঃ০০টা - সন্ধা ৬ঃ০০টা</p>
                  </div>
                </div>
              </div>

              {/* form section */}
              <div className="contact-us-card">
                <div className="grid grid-cols-12 gap-6">
                   

                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* map */}
      </section>
        <div className="contact-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14607.669730920583!2d90.38725119572437!3d23.750323596933033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b9002bac6b3d%3A0x45a71f1828612443!2zRm9jdXMgRmFybWdhdGUgQnJhbmNoICgg4Kar4KeL4KaV4Ka-4Ka4IOCmh-CmieCmqOCmv-CmreCmvuCmsOCnjeCmuOCmv-Cmn-CmvyDgppXgp4vgpprgpr_gpoIg4Ka44KeH4Kao4KeN4Kaf4Ka-4KawKQ!5e0!3m2!1sen!2sbd!4v1756204933485!5m2!1sen!2sbd" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </>
  );
}
